import { useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { useEffect, useState } from "react";
import RequestForRemovalForm from "../components/RequestForRemovalForm";

export const RequestForRemoval = () => {

    const { instance, inProgress } = useMsal();
    const isAuthenticated = instance.getActiveAccount() !== null;


    useEffect(() => {

        if (inProgress === InteractionType.None && !isAuthenticated) {
            instance.loginRedirect("/Home");
        }

    }, [instance, inProgress, isAuthenticated]);

    return (
        <>
            <div>
                <div label="Request for Removal">
                    <RequestForRemovalForm />
                </div>
            </div>
        </>
    );
}